import { React } from "react";
import { Button } from "antd";

const CommonButton = ({ label, onClick, disabled, className, style, name, htmlType, type, loading, key, icon }) => {
  return (
    <Button
      name={name}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={style}
      htmlType={htmlType}
      type={type}
      loading={loading}
      key={key}
      icon={icon}
    >
      {label}
    </Button>
  );
};

export default CommonButton;
